import * as React from 'react';
import { LinkButton } from '@cian/ui-kit/button';
import { InlineText1, InlineText3 } from '@cian/ui-kit/typography';
import { ILayout } from '../../../../types/newbuilding/layouts';
import * as style from './SlideInfo.css';

interface ICounterProps {
  currentSlide: ILayout | undefined;
  onButtonClick(): void;
}

export const SlideInfo: React.StatelessComponent<ICounterProps> = props => {
  const { currentSlide, onButtonClick } = props;

  if (!currentSlide) {
    return null;
  }

  return (
    <div className={style['container']}>
      <div className={style['price_meter']}>
        <InlineText3 color={'gray60_100'}>{currentSlide.roomsSquareMeterPriceText}</InlineText3>
      </div>
      <div className={style['price_total']}>
        <InlineText1 fontWeight={'bold'}>{currentSlide.totalAreaPriceText}</InlineText1>
      </div>
      <LinkButton
        theme={'fill_primary'}
        href={currentSlide.searchButtonLink}
        target={'_blank'}
        onClick={onButtonClick}
        size={'XS'}
      >
        Показать предложения
      </LinkButton>
    </div>
  );
};
